import React from 'react'

import useStyles from '../styles'
import useDrawerFormStyles from '../../../../../../../../styles/common/drawerForms'

const VideoSupportedFormatsAndSizes = () => {
  const classes = useStyles()
  const drawerFormClasses = useDrawerFormStyles()

  return (
    <section className={drawerFormClasses.section}>
      <h4 className={drawerFormClasses.sectionTitle}>Supported formats:</h4>
      <ul className={classes.list}>
        <li>.avi</li>
        <li>.mov</li>
        <li>.mp4</li>
        <li>.m4v</li>
        <li>.mpeg</li>
        <li>.mpg</li>
        <li>.webm</li>
        <li>.wmv</li>
      </ul>
      <br />
      <h4 className={drawerFormClasses.sectionTitle}>Supported sizes:</h4>
      <ul className={classes.list}>
        <li>Landscape/horizontal: 1280 × 720, 1920 × 1080, or 1440 × 1080</li>
        <li>Portrait/vertical: 720 × 1280, 1080 × 1920, or 1080 × 1440 </li>
        <li>Square: 720 × 720, 1080 × 1080, 1920 × 1920</li>
      </ul>
    </section>
  )
}

export default VideoSupportedFormatsAndSizes
